export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-900 text-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h3 className="font-heading text-xl text-background-50 mb-4">爱豆影视</h3>
            <p className="text-sm text-background-300 leading-relaxed">
              爱豆影视为您提供热门综艺、真人秀、偶像综艺高清免费在线观看，不缓冲不卡顿，流畅播放全集。每日更新最新偶像团体综艺内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
            <ul className="space-y-2">
              {[
                { label: '热门推荐', href: '#cards' },
                { label: '热播榜单', href: '#ranking' },
                { label: '精彩看点', href: '#media' },
                { label: '最新动态', href: '#updates' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">综艺分类</h4>
            <ul className="space-y-2">
              {[
                { label: '偶像团体综艺', href: '#index' },
                { label: '选秀竞技节目', href: '#index' },
                { label: '户外真人秀', href: '#index' },
                { label: '音乐舞台纯享', href: '#media' },
                { label: '幕后花絮', href: '#media' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-300 leading-relaxed mb-4">
              爱豆影视期待与更多优质内容方建立合作关系，共同为观众带来更好的综艺观影体验。
            </p>
            <div className="flex gap-3">
              <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="w-9 h-9 rounded-lg bg-secondary-700 hover:bg-secondary-600 flex items-center justify-center transition-colors cursor-pointer" aria-label="联系邮箱">
                <i className="ri-mail-line text-background-200 text-sm"></i>
              </a>
              <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="w-9 h-9 rounded-lg bg-secondary-700 hover:bg-secondary-600 flex items-center justify-center transition-colors cursor-pointer" aria-label="在线客服">
                <i className="ri-customer-service-2-line text-background-200 text-sm"></i>
              </a>
              <a href="#faq" onClick={(e) => { e.preventDefault(); document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' }); }} className="w-9 h-9 rounded-lg bg-secondary-700 hover:bg-secondary-600 flex items-center justify-center transition-colors cursor-pointer" aria-label="常见问题">
                <i className="ri-question-line text-background-200 text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400 text-center sm:text-left">
            &copy; 2026 爱豆影视 — 偶像综艺高清免费在线观看平台。本站所有内容仅供学习交流，请于下载后24小时内删除。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <a href="#hero" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }} className="hover:text-background-200 transition-colors cursor-pointer">回到顶部</a>
            <a href="#faq" onClick={(e) => { e.preventDefault(); document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' }); }} className="hover:text-background-200 transition-colors cursor-pointer">常见问题</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="hover:text-background-200 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}